import * as React from "react";
import { Alert, Gray100 } from "@traceair/tds";
import { style } from "typestyle";

const containerStyle = style({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: "8px 0",
});

const labelStyle = style({
  fontWeight: "500",
  fontSize: "12px",
  lineHeight: "14px",
  letterSpacing: "-0.25px",
  color: Gray100,
});

const valueStyle = style({
  fontWeight: "700",
  fontSize: "16px",
  lineHeight: "16px",
  color: "#000000",
  margin: "2px 0 0 0",
  letterSpacing: 0,
});

interface ICoordinateRowProps {
  label: string;
  value: string;
}

const CoordinateRow: React.FC<ICoordinateRowProps> = ({ label, value }) => (
  <div>
    <div className={labelStyle}>{label}</div>
    <div className={valueStyle}>{value}</div>
  </div>
);

interface ICoordinatesProps {
  lat: number;
  lng: number;
  alt: number;
  className?: string;
}

const Coordinates: React.FC<ICoordinatesProps> = ({
  lat,
  lng,
  alt,
  className = "",
}) => {
  return (
    <div className={className}>
      <Alert
        title={
          <div className={containerStyle}>
            <div className={labelStyle}>Coordinates (WGS84*)</div>
            <CoordinateRow label="Latitude" value={`${lat}°`} />
            <CoordinateRow label="Longtitude" value={`${lng}°`} />
            <CoordinateRow label="Altitude" value={`${alt.toFixed(3)} m`} />
          </div>
        }
        type="neutral"
      />
    </div>
  );
};

export default Coordinates;
